import { Component, OnInit, Input } from '@angular/core';
import { formatPercent } from '@angular/common';

@Component({
    selector: 'ifc-chart-circular-percentage',
    templateUrl: './chart-circular-percentage.component.html',
    styleUrls: ['./chart-circular-percentage.component.scss'],
    standalone: false
})
export class ChartCircularPercentageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.label = this.label || formatPercent(this.factor, 'en_US');
  }

  @Input()
  caption1: string;

  @Input()
  caption2: string;

  @Input()
  factor = 0;

  @Input()
  label: string;

  get percentage() {
    return this.factor * 100;
  }
}
